#import "~/graphql/fragments/User.graphql"
#import "~/graphql/fragments/Specialisation.graphql"
#import "~/graphql/fragments/Tag.graphql"

fragment Video on Video {
    id
    created_at
    updated_at
    title
    slug
    status
    description
    bunny_id
    bunny_thumbnail
    bunny_views
    medical_tools_used
    conflict_of_interest
    conflict_of_interest_explanation
    views: viewsCount

    user {
        ...User
    }

    specialisations {
        ...Specialisation
    }

    tags {
        ...Tag
    }
}
